import { Box, Typography, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const PopUp = ({ open, onClose, title, children }) => {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop, not the popup itself
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={1300}
      style={{
        background: "rgba(0,0,0,0.3)",
        paddingLeft: 24,
        paddingRight: 24,
      }}
      onClick={handleBackdropClick}
    >
      <Box
        bgcolor="var(--ikaro-text-white)"
        p={3}
        borderRadius={8}
        boxShadow={3}
        minWidth={300}
        position="relative"
        maxHeight="90vh"
        maxWidth="90vw"
        overflow="auto"
      >
        {title && (
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
        )}
        <Box style={{ marginBottom: 16 }}>
          {children}
        </Box>
        <IconButton
          style={{ position: "absolute", top: 8, right: 8 }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PopUp;
